module.exports = __webpack_public_path__ + "img/fi-rr-time-quarter-past.823d53e4.svg";